import React from "react";
import { Link } from "react-router-dom";
import CompanyBanner from "./CompanyBanner";
import "./Home.css";

const Home = () => (
  <>
    {/* ---------- HERO SECTION ---------- */}
    <section className="hero">
      <div className="hero-grid-overlay"></div>
      <div className="hero-background">
        <div className="sunburst"></div>
        <div className="hero-overlay"></div>
      </div>

      <div className="container hero-content">
        <span className="hero-badge animate-fade-up">
          More than technology.
        </span>
        <h1 className="hero-title animate-fade-up">
          Build Your <span className="text-gradient">Digital Presence</span>
        </h1>
        <p className="hero-subtitle animate-fade-up">
          We engineer pristine websites, tailored applications, and
          high-performance technology solutions that scale companies
          beautifully.
        </p>
        <div className="hero-actions animate-fade-up">
          <Link to="/what-we-do" className="btn-modern btn-filled">
            Explore Our Work
          </Link>
          <Link to="/contact" className="btn-modern btn-bordered">
            Start a Conversation
          </Link>
        </div>
      </div>
    </section>

    {/* ---------- COMPANY BANNER ---------- */}
    <CompanyBanner />

    {/* ---------- WHAT WE OFFER ---------- */}
    <section className="services-section">
      <div className="container">
        <div className="section-header-center">
          <h2 className="section-title">
            Digital Solutions That{" "}
            <span className="text-gradient-amber">Deliver</span>
          </h2>
          <p className="section-subtitle">
            From modern frontends to bulletproof backend engineering, we manage
            the architecture of your online success.
          </p>
        </div>
      </div>

      <div className="container services-grid">
        <div className="modern-service-card">
          <div className="card-glow"></div>
          <div className="card-content">
            <span className="card-icon">𖦹</span>
            <h3>Web Design & Development</h3>
            <p>
              Custom, edge-optimized responsive ecosystems designed to map
              perfectly to your user experience pipelines.
            </p>
          </div>
        </div>

        <div className="modern-service-card">
          <div className="card-glow"></div>
          <div className="card-content">
            <span className="card-icon">𖦹</span>
            <h3>Hosting & Cloud Infrastructure</h3>
            <p>
              Secure global standard deployment networks featuring high
              redundancy configurations and daily automated snapshots.
            </p>
          </div>
        </div>

        <div className="modern-service-card">
          <div className="card-glow"></div>
          <div className="card-content">
            <span className="card-icon">𖦹</span>
            <h3>Custom Applications</h3>
            <p>
              Scalable software dashboards engineered with strict performance
              parameters to accelerate structural growth.
            </p>
          </div>
        </div>

        <div className="modern-service-card">
          <div className="card-glow"></div>
          <div className="card-content">
            <span className="card-icon">𖦹</span>
            <h3>Unified Communication</h3>
            <p>
              Premium domain mail systems, automated newsletters, and systemic
              workflow sequences structured securely.
            </p>
          </div>
        </div>
      </div>

      <div className="container text-center" style={{ marginTop: "4rem" }}>
        <Link to="/what-we-do" className="btn-modern btn-filled">
          View All Capabilities
        </Link>
      </div>
    </section>

    {/* ---------- WHY KAFUE ---------- */}
    <section className="why-section">
      <div className="container why-grid">
        <div className="why-image-wrapper">
          <div className="image-border-gradient"></div>
          <img
            src="https://images.unsplash.com/photo-1521790797524-b2497295b8a0?q=80&w=1469&auto=format&fit=crop"
            alt="Kafue Technologies architectural brainstorming session"
            className="rounded-image-sleek"
          />
        </div>

        <div className="why-text">
          <span className="section-badge">Our DNA</span>
          <h2 className="section-title">
            Why <span className="text-gradient-amber">Kafue?</span>
          </h2>
          <p>
            We operate at the convergence of local insight and global software
            standards. Inspired by the continuous, adaptive momentum of the
            Kafue River, we treat digital systems as living engineering entities
            that must scale organically.
          </p>
          <p>
            Whether implementing clean microservices or bespoke enterprise
            software, our craftsmanship is bound by precision, architectural
            clarity, and extreme dedication.
          </p>

          {/* Realizing the missing stats layout block */}
          <div className="why-stats">
            <div className="stat-item">
              <strong>+40%</strong>
              <span>Conversion Growth</span>
            </div>
            <div className="stat-item">
              <strong>99.9%</strong>
              <span>Uptime Maintained</span>
            </div>
            <div className="stat-item">
              <strong>100%</strong>
              <span>Bespoke Codebase</span>
            </div>
          </div>

          <Link
            to="/about"
            className="btn-modern btn-bordered"
            style={{ marginTop: "2rem", display: "inline-block" }}
          >
            Learn More About Us
          </Link>
        </div>
      </div>
    </section>

    {/* ---------- TESTIMONIAL ---------- */}
    <section className="testimonial-section">
      <div className="container text-center">
        <div className="quote-mark">“</div>
        <blockquote className="testimonial-sleek">
          Kafue Technologies transformed our structural presence online. Our
          transaction architectures scaled perfectly, yielding exceptional
          volume growth within three operational months.
        </blockquote>
        <cite className="testimonial-cite-modern">
          Touch of Love Hair Salon
        </cite>
        <div style={{ marginTop: "3.5rem" }}>
          <Link to="/contact" className="btn-modern btn-filled">
            Initiate Your Engineering Pipeline
          </Link>
        </div>
      </div>
    </section>
  </>
);

export default Home;
